import { useNavigate, useLocation } from "react-router-dom";
import { Home, CakeSlice, PackageSearch, User, LayoutDashboard } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

const TABS = [
  { to: "/", label: "Home", icon: Home, match: (p) => p === "/" },
  { to: "/order", label: "Order", icon: CakeSlice, match: (p) => p.startsWith("/order") },
  { to: "/track", label: "Track", icon: PackageSearch, match: (p) => p.startsWith("/track") },
  { to: "/account", label: "Account", icon: User, match: (p) => ["/account", "/login", "/register"].some((x) => p.startsWith(x)) },
];

const ADMIN_TABS = [
  TABS[0],
  TABS[1],
  { to: "/admin", label: "Dashboard", icon: LayoutDashboard, match: (p) => p.startsWith("/admin") },
  TABS[3],
];

const TabBar = () => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const { user } = useAuth();
  const tabs = user?.role === "admin" ? ADMIN_TABS : TABS;
  return (
    <nav data-testid="app-tabbar" className="shrink-0 border-t border-sugar-border bg-sugar-bg/95 backdrop-blur-xl">
      <div className="mx-auto grid max-w-md grid-cols-4 px-2 pb-2 pt-2.5">
        {tabs.map((t) => {
          const active = t.match(pathname);
          const Icon = t.icon;
          return (
            <button
              key={t.to}
              data-testid={`tab-${t.label.toLowerCase()}`}
              onClick={() => navigate(t.to)}
              className="flex flex-col items-center gap-1 py-1"
            >
              <span className={`grid h-9 w-12 place-items-center rounded-full transition-all ${active ? "bg-sugar-ink text-sugar-bg" : "text-sugar-ink2"}`}>
                <Icon size={19} strokeWidth={active ? 2.4 : 2} />
              </span>
              <span className={`text-[10px] font-bold uppercase tracking-wider ${active ? "text-sugar-ink" : "text-sugar-muted"}`}>{t.label}</span>
            </button>
          );
        })}
      </div>
    </nav>
  );
};

export const AppFrame = ({ children }) => {
  const { pathname } = useLocation();
  const wide = pathname.startsWith("/admin");
  return (
    <div className="flex min-h-[100dvh] w-full flex-col items-center bg-sugar-bg">
      <div className={`relative flex h-[100dvh] w-full flex-col overflow-hidden bg-sugar-bg ${wide ? "md:max-w-6xl" : "md:max-w-3xl"}`}>
        <div className="flex-1 overflow-y-auto overflow-x-hidden no-scrollbar">{children}</div>
        <TabBar />
      </div>
    </div>
  );
};
